var _dec, _dec2, _dec3, _class, _descriptor;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import { CustomerService } from '@square/dashboard-protos/models/squareup/sfs/external/services/customer/customer_service';
import Service, { inject as service } from '@ember/service';
import { computed, set } from '@ember/object';
import rpc, { apiHostUrl } from '@banking/api/utils/rpc';
import { Money, Currency } from '@square/dashboard-protos/models/squareup/connect/v2/common/money';
let SfsCustomerApi = (_dec = computed('capitalEngineContext.headers'), _dec2 = computed('customerLimits.{odfiDepositAmountLimit,odfiDepositAmountSum}'), _dec3 = computed('customerLimits.{odfiWithdrawalAmountLimit,odfiWithdrawalAmountSum}'), (_class = class SfsCustomerApi extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "capitalEngineContext", _descriptor, this);
    _defineProperty(this, "features", []);
    _defineProperty(this, "currentCustomer", void 0);
    _defineProperty(this, "customerLimits", void 0);
  }
  get client() {
    return CustomerService.create(rpc(apiHostUrl, new Map(Object.entries(this.capitalEngineContext.headers))));
  }
  get remainingWeeklyDeposits() {
    if (this.customerLimits?.odfiDepositAmountLimit && this.customerLimits?.odfiDepositAmountSum) {
      const {
        odfiDepositAmountLimit,
        odfiDepositAmountSum
      } = this.customerLimits;
      if (odfiDepositAmountLimit.currency !== odfiDepositAmountSum.currency) {
        throw new Error(`Can not subtract Money objects with different currency codes:
            ${odfiDepositAmountLimit.currency} vs. ${odfiDepositAmountSum.currency}`);
      }
      const amount = odfiDepositAmountLimit.amount - odfiDepositAmountSum.amount;
      return Money.create({
        amount,
        currency: Currency.USD
      });
    } else {
      return null;
    }
  }
  get remainingWeeklyWithdrawals() {
    if (this.customerLimits?.odfiWithdrawalAmountLimit && this.customerLimits?.odfiWithdrawalAmountSum) {
      const {
        odfiWithdrawalAmountLimit,
        odfiWithdrawalAmountSum
      } = this.customerLimits;
      if (odfiWithdrawalAmountLimit.currency !== odfiWithdrawalAmountSum.currency) {
        throw new Error(`Can not subtract Money objects with different currency codes:
            ${odfiWithdrawalAmountLimit.currency} vs. ${odfiWithdrawalAmountSum.currency}`);
      }
      const amount = odfiWithdrawalAmountLimit.amount - odfiWithdrawalAmountSum.amount;
      return Money.create({
        amount,
        currency: Currency.USD
      });
    } else {
      return null;
    }
  }

  // eslint-disable-next-line unicorn/no-object-as-default-parameter
  async retrieveCustomer({
    refresh
  } = {
    refresh: false
  }) {
    if (!this.currentCustomer || refresh) {
      const {
        customer,
        featureFlags
      } = await this.client.retrieveCustomer({});
      set(this, 'currentCustomer', customer);
      this.features = [];
      for (const feature of featureFlags?.flags ?? []) {
        this.features.push(feature);
      }
    }

    // Make sure we don't return a nullable customer. This should never happen
    // but technically the field on the proto is nullable.
    if (!this.currentCustomer) {
      throw new Error('failed to retrieve customer');
    }
    return {
      customer: this.currentCustomer,
      features: this.features
    };
  }

  // eslint-disable-next-line unicorn/no-object-as-default-parameter
  async retrieveCustomerLimits({
    refresh
  } = {
    refresh: false
  }) {
    if (!this.customerLimits || refresh) {
      const {
        customerLimits
      } = await this.client.retrieveCustomerLimits({});
      set(this, 'customerLimits', customerLimits);
    }

    // Make sure we don't return a nullable customer limits. This should never happen
    // but technically the field on the proto is nullable.
    if (!this.customerLimits) {
      throw new Error('failed to retrieve customer limits');
    }
    return {
      customerLimits: this.customerLimits
    };
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "capitalEngineContext", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "client", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "client"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "remainingWeeklyDeposits", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "remainingWeeklyDeposits"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "remainingWeeklyWithdrawals", [_dec3], Object.getOwnPropertyDescriptor(_class.prototype, "remainingWeeklyWithdrawals"), _class.prototype)), _class));
export { SfsCustomerApi as default };